var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      <img class=\"p-cp-comment-list__item__content__user__icon\" src=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.User)),stack1 == null || stack1 === false ? stack1 : stack1.image_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n      <p class=\"p-cp-comment-list__item__content__user__name\">\n        "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.User)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.User)),stack1 == null || stack1 === false ? stack1 : stack1.Child), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </p>\n    ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          <span class=\"p-cp-comment-list__item__content__user__name__child\">("
    + escapeExpression(__default(require("../js/hbs_helpers/joinChildBirthday.js")).call(depth0, ((stack1 = (depth0 && depth0.User)),stack1 == null || stack1 === false ? stack1 : stack1.Child), {hash:{},data:data}))
    + ")</span>\n        ";
  return buffer;
  }

function program4(depth0,data) {
  
  
  return "\n      <img class=\"p-cp-comment-list__item__content__user__icon\" src=\"//cdn.mamari.jp/static/mamariQ/img/campaign/common/icon_unknown-user-thumb.png\">\n      <p class=\"p-cp-comment-list__item__content__user__name\">退会ユーザー</p>\n    ";
  }

function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <img class=\"p-cp-comment-list__item__content__img\" src=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.CampaignComment)),stack1 == null || stack1 === false ? stack1 : stack1.image_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n  ";
  return buffer;
  }

function program8(depth0,data) {
  
  
  return "\n      <a\n        class=\"p-cp-comment-list__item__content__meta__delete js-campaign-comment-remove\"\n        href=\"javascript://\"\n        style=\"background: url(//cdn.mamari.jp/static/mamariQ/img/campaign/common/icon_delete.png) no-repeat left center; background-size: contain\"></a>\n    ";
  }

  buffer += "<div class=\"p-cp-comment-list__item__content\">\n  <a class=\"p-cp-comment-list__item__content__user\" href=\"/user/"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.User)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.User)),stack1 == null || stack1 === false ? stack1 : stack1.id), {hash:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </a>\n\n  <p class=\"p-cp-comment-list__item__content__desc\">"
    + escapeExpression(__default(require("../js/hbs_helpers/nl2br.js")).call(depth0, ((stack1 = (depth0 && depth0.CampaignComment)),stack1 == null || stack1 === false ? stack1 : stack1.content), {hash:{},data:data}))
    + "</p>\n\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CampaignComment)),stack1 == null || stack1 === false ? stack1 : stack1.image), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <div class=\"p-cp-comment-list__item__content__meta\">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CampaignComment)),stack1 == null || stack1 === false ? stack1 : stack1.is_own), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    <p class=\"p-cp-comment-list__item__content__meta__date\">\n      "
    + escapeExpression(__default(require("../js/hbs_helpers/relativeTime.js")).call(depth0, ((stack1 = (depth0 && depth0.CampaignComment)),stack1 == null || stack1 === false ? stack1 : stack1.created), {hash:{},data:data}))
    + "\n    </p>\n  </div>\n</div>\n";
  return buffer;
  });


//////////////////
// WEBPACK FOOTER
// ./webroot/hbs/campaign_comment.hbs
// module id = 217
// module chunks = 0